import { Space } from "antd";
import { OrderedListOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import { TableColumnsType } from "antd";
import { Task } from "@rumble-it/common-lib/types/models/Task.interface";
import { Modal } from "@/components/v2";
import { Button, Card, CardFooter, Checkbox } from "@rumbledirect/ui";

interface TasksColumnsModalProps {
  visibleKeys: string[];
  setVisibleKeys: (keys: string[]) => void;
  columns: TableColumnsType<Task>;
}

export const TasksColumnsModal = ({
  visibleKeys,
  setVisibleKeys,
  columns,
}: TasksColumnsModalProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tempSelectedKeys, setTempSelectedKeys] =
    useState<string[]>(visibleKeys);

  useEffect(() => {
    setTempSelectedKeys(visibleKeys);
  }, [visibleKeys]);

  const options = columns
    .filter((col) => col.key)
    .map((col) => ({
      label: col.title as string,
      value: col.key as string,
    }));

  const handleOk = () => {
    setVisibleKeys(tempSelectedKeys);
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        icon={<OrderedListOutlined />}
        onClick={() => setIsModalOpen(true)}
      >
        Kolommen
      </Button>

      <Modal open={isModalOpen} onCancel={() => setIsModalOpen(false)}>
        <Card title="Kolommen selecteren">
          <Space className="mb-4">
            <Button
              size="small"
              onClick={() =>
                setTempSelectedKeys(options.map((option) => option.value))
              }
            >
              Alles selecteren
            </Button>
            <Button size="small" onClick={() => setTempSelectedKeys([])}>
              Alles deselecteren
            </Button>
          </Space>

          <Checkbox.Group
            options={options}
            value={tempSelectedKeys}
            onChange={(checkedValues) =>
              setTempSelectedKeys(checkedValues as string[])
            }
            className="flex flex-col gap-2"
          />

          <CardFooter>
            <Button onClick={() => setIsModalOpen(false)}>Annuleren</Button>

            <Button type="primary" htmlType="submit" onClick={() => handleOk()}>
              Toepassen
            </Button>
          </CardFooter>
        </Card>
      </Modal>
    </>
  );
};
